import React from "react";
import MobileMenuHeader from "./mobile-menu-header";
import MobileNavigationItem from "../MobileNavigationItem";

export interface NavigationItemData {
  name: string;
  href?: string;
  current?: boolean;
  children?: NavigationItemData[];
}

interface MobileMenuProps {
  isOpen: boolean;
  navigation: NavigationItemData[];
  openMenus: string[];
  onToggleMenu: (name: string) => void;
  onClose: () => void;
  isDarkMode: boolean;
  onThemeToggle: () => void;
}

/**
 * Full-screen mobile navigation overlay.
 * Shows below the header with accordion-style expandable menu items.
 */
const MobileMenu: React.FC<MobileMenuProps> = ({
  isOpen,
  navigation,
  openMenus,
  onToggleMenu,
  onClose,
  isDarkMode,
  onThemeToggle,
}) => {
  if (!isOpen) return null;

  const isMenuOpen = (menuName: string): boolean => openMenus.includes(menuName);

  return (
    <div className="xl:hidden fixed inset-x-0 top-16 z-30 max-h-[calc(100vh-4rem)] overflow-y-auto bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 shadow-lg">
      <MobileMenuHeader isDarkMode={isDarkMode} onThemeToggle={onThemeToggle} onClose={onClose} />

      {/* Navigation Items */}
      <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        {navigation.map((item) => (
          <MobileNavigationItem
            key={item.name}
            name={item.name}
            href={item.href}
            current={item.current}
            children={item.children}
            isMenuOpen={isMenuOpen(item.name)}
            onToggle={() => onToggleMenu(item.name)}
            onClose={onClose}
          />
        ))}
      </div>
    </div>
  );
};

export default MobileMenu;
